import { createContext } from 'react';

type RuntimeContext = {
    isMobile: boolean;
    collator: Intl.Collator | null;
}

export const RuntimeContext = createContext<RuntimeContext>({
    isMobile: false,
    collator: null,
});
